<div class="diagnostics-modal">
  <div class="modal-header">
    <h2>Login Diagnostics</h2>
    <button type="button" mat-icon-button (click)="close()" class="close-btn">
      <i class="icon-x"></i>
    </button>
  </div>

  <div class="modal-content">
    <div class="diagnostic-section">
      <h3>Authentication</h3>
      <div class="diagnostic-row">
        <span class="label">Auth Type:</span>
        <span class="value" [class.success]="data.success" [class.error]="!data.success">
          {{ data.authType }}
        </span>
      </div>
      <div class="diagnostic-row" *ngIf="data.callSite">
        <span class="label">Call Site:</span>
        <span class="value code">{{ data.callSite }}</span>
      </div>
      <div class="diagnostic-row">
        <span class="label">Status:</span>
        <span class="value" [class.success]="data.success" [class.error]="!data.success">
          {{ data.success ? 'SUCCESS ✓' : 'FAILED ✗' }}
        </span>
      </div>
      <div class="diagnostic-row">
        <span class="label">Timestamp:</span>
        <span class="value">{{ data.timestamp | date:'short' }}</span>
      </div>
    </div>

    <div class="diagnostic-section">
      <h3>Network Information</h3>
      <div class="diagnostic-row">
        <span class="label">Network Type:</span>
        <span class="value">{{ data.networkType || 'Unknown' }}</span>
      </div>
      <div class="diagnostic-row">
        <span class="label">Network Available:</span>
        <span class="value" [class.success]="data.networkAvailable" [class.error]="!data.networkAvailable">
          {{ data.networkAvailable ? 'Yes ✓' : 'No ✗' }}
        </span>
      </div>
      <div class="diagnostic-row">
        <span class="label">Network Switching:</span>
        <span class="value" [class.warning]="data.networkSwitching">
          {{ data.networkSwitching ? 'Yes ⚠' : 'No' }}
        </span>
      </div>
    </div>

    <div class="diagnostic-section">
      <h3>Retry Information</h3>
      <div class="diagnostic-row">
        <span class="label">Retries Used:</span>
        <span class="value">{{ data.retriesUsed }} / {{ data.maxRetries }}</span>
      </div>
      <div class="retry-bar">
        <div class="retry-progress"
             [style.width.%]="(data.retriesUsed / data.maxRetries) * 100"
             [class.success]="data.success"
             [class.error]="!data.success">
        </div>
      </div>
    </div>

    <div class="diagnostic-section">
      <h3>Device Information</h3>
      <div class="diagnostic-row">
        <span class="label">Platform:</span>
        <span class="value">{{ data.platform }}</span>
      </div>
      <div class="diagnostic-row" *ngIf="data.osVersion">
        <span class="label">OS Version:</span>
        <span class="value">{{ data.osVersion }}</span>
      </div>
      <div class="diagnostic-row" *ngIf="data.modelName">
        <span class="label">Device Model:</span>
        <span class="value">{{ data.modelName }}</span>
      </div>
    </div>

    <div class="diagnostic-section" *ngIf="!data.success">
      <h3>Failure Details</h3>
      <div class="diagnostic-row" *ngIf="data.hadCachedProfile !== undefined">
        <span class="label">Had Cached Profile:</span>
        <span class="value" [class.success]="data.hadCachedProfile" [class.error]="!data.hadCachedProfile">
          {{ data.hadCachedProfile ? 'Yes ✓' : 'No ✗' }}
        </span>
      </div>
      <div class="diagnostic-row" *ngIf="data.accessTokenValid !== undefined">
        <span class="label">Access Token Valid:</span>
        <span class="value" [class.success]="data.accessTokenValid" [class.error]="!data.accessTokenValid">
          {{ data.accessTokenValid ? 'Yes ✓' : 'No ✗' }}
        </span>
      </div>
      <div class="diagnostic-row" *ngIf="data.refreshTokenValid !== undefined">
        <span class="label">Refresh Token Valid:</span>
        <span class="value" [class.success]="data.refreshTokenValid" [class.error]="!data.refreshTokenValid">
          {{ data.refreshTokenValid ? 'Yes ✓' : 'No ✗' }}
        </span>
      </div>
      <div class="diagnostic-row" *ngIf="data.error">
        <span class="label">Error:</span>
        <span class="value error">{{ data.error }}</span>
      </div>
    </div>

    <div class="diagnostic-section info-box">
      <p><strong>What this means:</strong></p>
      <ul>
        <li *ngIf="data.networkSwitching">
          <i class="icon-alert icon-orange"></i>
          Network was switching during login - this may cause delays
        </li>
        <li *ngIf="data.retriesUsed > 1">
          <i class="icon-info icon-action-blue"></i>
          Required {{ data.retriesUsed }} attempts to connect
        </li>
        <li *ngIf="!data.networkAvailable">
          <i class="icon-alert icon-red"></i>
          Network was unavailable - using offline mode
        </li>
        <li *ngIf="data.success && data.retriesUsed === 1">
          <i class="icon-check icon-green"></i>
          Login successful on first attempt
        </li>
      </ul>
    </div>
  </div>

  <div class="modal-actions">
    <button type="button" mat-stroked-button (click)="copyToClipboard()">
      <i class="icon-copy"></i>
      Copy Details
    </button>
    <button type="button" mat-raised-button color="primary" (click)="close()">
      Close
    </button>
  </div>
</div>
